import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConsentService, CONSENT_SERVICES } from '@modules/consent/consent.service';

@Component({
  selector: 'mb-external-player',
  templateUrl: './external-player.component.html',
  styleUrls: ['./external-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ExternalPlayerComponent implements OnInit {
  @Input() embedCode? = '';
  @Input() title? = '';

  @Output() backButton = new EventEmitter();

  public consentProviderConfig: CONSENT_SERVICES = CONSENT_SERVICES.YOUTUBE;
  public bypassedEmbedHTML?: SafeHtml;
  public backgroundImageUrl = '';

  constructor(private sanitizer: DomSanitizer, private consentService: ConsentService) {}

  ngOnInit() {
    // TODO: select correct consent service based on embedCode heuristic (or add a field for editors...),
    //       once we allow other providers than Youtube
    if (this.embedCode) {
      this.bypassedEmbedHTML = this.sanitizer.bypassSecurityTrustHtml(this.embedCode);

      // parse videoId to generate a background image
      const findYTVideoId = /src=\"https:\/\/www\.youtube\.com\/embed\/([0-9a-zA-Z]*)\"/gm.exec(this.embedCode);
      if (findYTVideoId?.[1]) {
        this.backgroundImageUrl = this.consentService.getYoutubeVideoBackgroundImageUrl(findYTVideoId?.[1]);
      }
    }
  }
}
